var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { Component } from 'react';
import { default as Cascader } from 'antd/lib/cascader';
import { isEqual, map, get, cloneDeep } from 'lodash';
import { services } from '@comall-backend-builder/core';

var TreeNodeCascader = function (_super) {
  __extends(TreeNodeCascader, _super);

  function TreeNodeCascader(props) {
    var _this = _super.call(this, props) || this;
    /**
     * Cascader选择完成后的回调
     * @param {array} value - 选中的节点的value
     * @param {array} selectedOptions - 选中的各级节点, 每个节点是一个对象
     */


    _this.onChange = function (_value, selectedOptions) {
      var selectedValue = map(selectedOptions, function (val) {
        var id = val.id,
            label = val.label;
        return {
          id: id,
          name: label
        };
      });
      var _a = _this.props,
          onChange = _a.onChange,
          name = _a.name;
      onChange(selectedValue, name);
    };
    /**
     * Cascader异步请求候选项的回调方法
     * @param {array} selectedOptions - 选中项
     */


    _this.loadData = function (selectedOptions) {
      var targetOption = selectedOptions[selectedOptions.length - 1];
      var targetId = targetOption.id;

      _this.setState({
        targetId: targetId
      });

      _this.loadOptions(targetId);
    };
    /**
     * 去加载对应节点的的option数据
     * @param {string} targetId - 要加载对应节点的Id
     */


    _this.loadOptions = function (targetId) {
      var _a = _this.props,
          name = _a.name,
          entity = _a.entity,
          params = _a.params,
          fieldSource = _a.fieldSource;

      if (fieldSource === 'properties') {
        var property = get(entity.metainfo.properties, name.split('.').join('.properties.'));
        entity.loadPropertyOptions(name, property.source, __assign(__assign({}, params), {
          id: targetId
        }));
      } else if (fieldSource === 'filters') {
        var filters = entity.metainfo.filters[name];
        entity.loadFilterOptions(name, filters.source, __assign(__assign({}, params), {
          id: targetId
        }));
      }
    };

    _this.onChange = _this.onChange.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.loadId = ''; //当前加载项的id, 用于加载的去重

    _this.state = {
      targetId: ''
    }; //当前选中的目标节点的id

    return _this;
  }
  /**
   * 在componentWillMount周期函数里进行对该组件的数据初始化加载
   */


  TreeNodeCascader.prototype.componentWillMount = function () {
    this.loadOptions(this.props.rootId);
  };

  TreeNodeCascader.prototype.shouldComponentUpdate = function (nextProps, nextState) {
    return !isEqual(this.props, nextProps) || this.state !== nextState;
  };

  TreeNodeCascader.prototype.render = function () {
    var _a = this.props,
        value = _a.value,
        _b = _a.placeholder,
        placeholder = _b === void 0 ? services.language.getText('common.pleaseSelect') : _b,
        options = _a.options,
        disabled = _a.disabled,
        showSearch = _a.showSearch,
        allowClear = _a.allowClear;
    var formatOptions = this.formatOptionsData(options);
    var valueIds = map(value, 'id');
    this.loadValueOptions(options, valueIds);
    var props = {
      value: valueIds,
      options: formatOptions,
      loadData: this.loadData,
      onChange: this.onChange,
      changeOnSelect: false,
      placeholder: placeholder,
      disabled: disabled,
      showSearch: showSearch,
      allowClear: allowClear
    };
    return React.createElement(Cascader, __assign({}, props));
  };
  /**
   * 用于格式化options
   * @param {array} options - 格式化前的options数据
   * @returns {array} 符合Cascader组件格式{id,label,value,loading,isLeaf,children}的数据源
   */


  TreeNodeCascader.prototype.formatOptionsData = function (options) {
    var _this = this;

    return map(options, function (val) {
      var id = val.id,
          name = val.name,
          isLeaf = val.isLeaf,
          children = val.children;
      var loading = _this.state.targetId === id && !isLeaf && !children;
      return {
        id: id,
        label: name,
        value: id,
        loading: loading,
        isLeaf: isLeaf,
        children: children ? _this.formatOptionsData(children) : undefined
      };
    });
  };
  /**
   * 加载value的options数据
   * @param {array} options - 当前的options数据
   * @param {array} valueIds - 由values中每一项的Id组成的数组
   */


  TreeNodeCascader.prototype.loadValueOptions = function (options, valueIds) {
    var values = cloneDeep(valueIds);

    for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
      var item = options_1[_i];
      var id = item.id,
          isLeaf = item.isLeaf,
          children = item.children;

      if (values.length > 0 && values[0] === id && !isLeaf) {
        if (!children && this.loadId !== id) {
          this.loadOptions(values[0]);
          this.loadId = id;
        } else if (children) {
          values.shift();
          this.loadValueOptions(children, values);
        }
      }
    }
  };

  TreeNodeCascader.defaultProps = {
    rootId: '0',
    fieldSource: 'properties'
  };
  return TreeNodeCascader;
}(Component);

export { TreeNodeCascader };